import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { FormControlLabel, RadioGroup } from '@mui/material';
import { startCase, map } from 'lodash';
import Radio from '@mui/material/Radio';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import React from 'react';
import useStyles from './style';

export default function FormMethodTwoFactorAuth(props) {
  const { classes } = useStyles();

  // influence page is using "TEXT" as sms method and no "email" property
  const fromInfluencePage =
    props.possibleMethods.sms === undefined &&
    props.possibleMethods.email === undefined;

  const isPhonePossible =
    props.possibleMethods.sms !== undefined ||
    props.possibleMethods.call !== undefined;
  return (
    <div className={classes.row}>
      <FormControl variant="standard" fullWidth>
        {fromInfluencePage ? (
          <>
            <FormLabel>Select an authentication method:</FormLabel>
            <RadioGroup name="method" value={props.method}>
              {map(props.possibleMethods, (m, label) => (
                <FormControlLabel
                  control={
                    <Radio
                      color="primary"
                      onChange={() => props.setMethod(m)}
                    />
                  }
                  key={m}
                  value={m}
                  label={
                    <span>
                      <b>{startCase(label)}</b>: {m}
                    </span>
                  }
                />
              ))}
            </RadioGroup>
          </>
        ) : (
          <>
            <span>Welcome to the Fashion Nova Vendor Portal.</span>
            <br />
            {isPhonePossible ? (
              <>
                <span>
                  For added security, we will send you a one-time code using the
                  method you select below.
                </span>
                <br />
                <FormLabel>Select an authentication method:</FormLabel>
                <RadioGroup name="method" value={props.method}>
                  {map(props.possibleMethods, (m, label) => (
                    <FormControlLabel
                      control={
                        <Radio
                          color="primary"
                          onChange={() => props.setMethod(label)}
                        />
                      }
                      key={label}
                      value={label}
                      label={
                        <span>
                          <b>{startCase(label)}</b>: {m}
                        </span>
                      }
                    />
                  ))}
                </RadioGroup>
              </>
            ) : (
              <span>
                {`For added security, we will send a one-time to your email address ${props.possibleMethods.email}.`}
              </span>
            )}
          </>
        )}
      </FormControl>
      <div className={classes.actions}>
        <Button
          color="primary"
          variant="contained"
          size="small"
          onClick={props.getCode}
        >
          Get Code
        </Button>
      </div>
      <br />
      <span>
        {`If you are having trouble, please contact us at
        ${fromInfluencePage ? 'influencerdocs@fashionnova.com' : 'vendormasterdata@fashionnova.com'}.`}
      </span>
    </div>
  );
}

FormMethodTwoFactorAuth.propTypes = {
  method: PropTypes.string.isRequired,
  possibleMethods: PropTypes.shape({
    email: PropTypes.string,
    sms: PropTypes.string,
    call: PropTypes.string,
  }).isRequired,
  getCode: PropTypes.func.isRequired,
  setMethod: PropTypes.func.isRequired,
};
